// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"container_parentContainer__1H5nR","childContainer":"container_childContainer__Du2gX"};